import React, { useState,useEffect } from 'react';
import firebase from "firebase/app";
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { useHistory } from 'react-router-dom';
import thanks from "./thanks.png";
import logo from './../rcrm_logo.png';
import './Thankyou.css'; // Optional: Import a CSS file for additional styling

const Thankyou = () => {
    const history = useHistory();
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true); // To handle the initial loading state

    // useEffect(() => {
    //     if(process.env.REACT_APP_LOAD_TESTING == 1){
    //         setLoading(false);
    //     }else{
    //         const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
    //             if (user) {
    //                 setUser(user);
    //                 setLoading(false); // Stop loading once the user is verified
    //             } else {
    //                 history.push('/login'); // Redirect immediately if not logged in
    //             }
    //         });
    //         return () => unsubscribe();
    //     }
        
    // }, [history]);

    const handleClickExit = () => {
        firebase.auth().signOut().then(() => {
        
            sessionStorage.clear();
            localStorage.clear();
            window.location.href = '/';
        }).catch((error) => {
            // If sign out fails, still redirect to main page
            sessionStorage.clear();
            localStorage.clear();
            window.location.href = '/';
        });
    };

    const handleGoToMainPage = () => {
        // Clear session and redirect to main page
        sessionStorage.clear();
        localStorage.clear();
        window.location.href = '/';
    };

    // if (loading) {
    //     // Optionally, return a loading spinner or message while checking auth status
    //     return <div>Loading...</div>;
    // }

    const checkn = sessionStorage.getItem("checkname");
    const checke = sessionStorage.getItem("checkemail");

    return (
        <div className="thankyou-wrapper">
            <div className="thankyou-header">
                <img src={logo} alt="RecruitCRM Logo" className="company-logo" />
            </div>
            
            <div className="thankyou-main-content">
                <div className="thankyou-card">
                    <div className="success-icon">
                        <div className="checkmark-circle">
                            <div className="checkmark"></div>
                        </div>
                    </div>
                    
                    <h1 className="submission-title">Assessment Successfully Submitted</h1>
                    
                    <div className="success-message">
                        <p className="primary-message">
                            Thank you for completing your assessment. Your responses have been securely submitted 
                            and are now being processed by our evaluation system.
                        </p>
                    </div>
                    
                    <div className="participant-info-section">
                        <h3 className="info-section-title">Participant Details</h3>
                        <div className="participant-card">
                            <div className="participant-detail">
                                <span className="detail-label">Full Name:</span>
                                <span className="detail-value">{checkn || 'Not provided'}</span>
                            </div>
                            <div className="participant-detail">
                                <span className="detail-label">Email Address:</span>
                                <span className="detail-value">{checke || 'Not provided'}</span>
                            </div>
                        </div>
                    </div>
                    
                    <div className="next-steps-section">
                        <h3 className="info-section-title">What Happens Next?</h3>
                        <div className="steps-list">
                            <div className="step-item">
                                <div className="step-number">1</div>
                                <div className="step-content">
                                    <strong>Evaluation Process:</strong> Our assessment team will thoroughly review your responses
                                </div>
                            </div>
                            <div className="step-item">
                                <div className="step-number">2</div>
                                <div className="step-content">
                                    <strong>Results Processing:</strong> Your performance will be analyzed and scored
                                </div>
                            </div>
                            <div className="step-item">
                                <div className="step-number">3</div>
                                <div className="step-content">
                                    <strong>Communication:</strong> Results will be shared through your registered email address
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="important-note">
                        
                        <p>
                        <p className="note-icon">ℹ️</p><strong>Important:</strong> Please ensure your contact information is up to date. 
                            Our team will reach out to you regarding the next steps in the evaluation process.
                        </p>
                    </div>
                    
                    <div className="action-section">
                        <Button 
                            id="exitExamWindowBtn"
                            variant="contained" 
                            className="exit-button"
                            onClick={handleGoToMainPage}
                            size="large"
                        >
                            <span className="button-icon">🏠</span>
                            Proceed to Main Portal
                        </Button>
                        <p className="exit-note">
                            Click above to navigate to the main application portal
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Thankyou;
